import * as React from "react";
import { useDispatch } from "react-redux";

import { setPbxId, setTenantId } from "@/react/features/customer/customerSlice";

/**
 * Return callbacks that take a React Select's current option and set the
 * values in the state.
 * @return {{onChangePbx: function(*): void, onChangeTenant: function(*): void}}
 */
const useHandlers = () => {
  const dispatch = useDispatch();
  return React.useMemo(() => {
    const onChangePbx = (option) => {
      const pbxId = option.value;
      dispatch(setPbxId(pbxId));
    };

    const onChangeTenant = (option) => {
      const tenantId = option.value;
      dispatch(setTenantId(tenantId));
    };

    return {
      onChangePbx,
      onChangeTenant,
    };
  }, [dispatch]);
};

export default useHandlers;
